// 96 DPI pixel values
export const PAGE_FORMAT_MAP: Record<string, {width: number; height: number}> = {
    // A Series
    a0: {width: 3179, height: 4494},
    a1: {width: 2245, height: 3179},
    a2: {width: 1587, height: 2245},
    a3: {width: 1123, height: 1587},
    a4: {width: 794, height: 1123},
    a5: {width: 559, height: 794},
    a6: {width: 397, height: 559},
    a7: {width: 280, height: 397},
    a8: {width: 197, height: 280},
    a9: {width: 140, height: 197},
    a10: {width: 98, height: 140},

    // B Series
    b0: {width: 3780, height: 5344},
    b1: {width: 2672, height: 3780},
    b2: {width: 1890, height: 2672},
    b3: {width: 1334, height: 1890},
    b4: {width: 945, height: 1334},
    b5: {width: 665, height: 945},
    b6: {width: 472, height: 665},
    b7: {width: 333, height: 472},
    b8: {width: 234, height: 333},
    b9: {width: 166, height: 234},
    b10: {width: 117, height: 166},

    // C Series
    c0: {width: 3466, height: 4902},
    c1: {width: 2449, height: 3466},
    c2: {width: 1731, height: 2449},
    c3: {width: 1225, height: 1731},
    c4: {width: 865, height: 1225},
    c5: {width: 612, height: 865},
    c6: {width: 431, height: 612},
    c7: {width: 306, height: 431},
    c8: {width: 215, height: 306},
    c9: {width: 151, height: 215},
    c10: {width: 106, height: 151},

    // Others
    dl: {width: 416, height: 832},
    letter: {width: 816, height: 1056},
    'government-letter': {width: 768, height: 1008},
    legal: {width: 816, height: 1344},
    'junior-legal': {width: 480, height: 768},
    ledger: {width: 1632, height: 1056},
    tabloid: {width: 1056, height: 1632},
    'credit-card': {width: 204, height: 324},

    // Aliases / Compatibility
    A4: {width: 794, height: 1123}
};
